import { FieldLabel } from 'components/core/dynamic-form/fields/FieldLabel'
import { RenderFieldProps, UnknownField } from 'components/core/dynamic-form/fields/RenderField'
import { C1LabeledTextField } from 'components/core/RHKFormComponents/C1LabeledTextField'
import { FC } from 'react'

export const RenderInt64Field: FC<RenderFieldProps> = ({ field, cField, errors, disabled }) => {
    if (field.type.oneofKind !== 'int64Field') return <UnknownField field={field} />

    const int64Field = field.type.int64Field

    switch (int64Field.view.oneofKind) {
        case 'numberField':
            return <C1LabeledTextField
                label={<FieldLabel name={field.displayName} required={field.required} />}
                name={field.name}
                placeholder={int64Field.placeholder || ''}
                error={!!errors[field.name]}
                helperText={(errors[field.name]?.message as string) || field.description}
                value={cField.value ?? ''}
                onChange={cField.onChange}
                fullWidth
                disabled={disabled}
                onBlur={cField.onBlur}
                type="number"
                inputMode="numeric"
                inputProps={{
                    min: int64Field.view.numberField.minValue !== undefined
                        ? Number(int64Field.view.numberField.minValue) : undefined,
                    max: int64Field.view.numberField.maxValue !== undefined
                        ? Number(int64Field.view.numberField.maxValue) : undefined,
                    step: int64Field.view.numberField.step !== undefined
                        ? Number(int64Field.view.numberField.step) : 1,

                }}
            />
        default:
            return <UnknownField field={field} />
    }
}
